import React from "react";
import SignIn from "../components/auth/SignIn";

export default function Admin() {
	return (
		<SignIn />
	);
}